"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToS = void 0;
const react_1 = __importDefault(require("react"));
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const Checkbox_1 = require("@food/ui/build/dist/src/Checkbox");
const theme_1 = require("../utils/theme");
const style = (0, css_manager_1.registerClass)(() => `
	> h3 {
		text-align: left;
	}
`);
const tosContainer = (0, css_manager_1.registerClass)((theme) => `
	flex-direction: col;
	max-height: 20em;
	font-size: ${theme.ratios.s * theme.font.baseSize}px;
	overflow: auto;
	padding: 0.5em;
	border: 1px solid ${theme.colors.grey.plain};
	text-align: left;
	max-width: 85vw;
`);
const ToS = ({ lang, tos, onAgree, onBack, t }) => {
    const [localLang, setLang] = react_1.default.useState(lang);
    const [extraChecked, toggleExtra] = react_1.default.useState(false);
    const text = tos[localLang === 'it_IT' ? 'description_ita' : 'description'];
    const extra = tos[localLang === 'it_IT' ? 'description_extra_ita' : 'description_extra'];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null, t `Registration - Terms & Conditions`),
        react_1.default.createElement("section", null,
            react_1.default.createElement("div", { className: style },
                react_1.default.createElement("div", { className: theme_1.defaultMarginBottom },
                    t `To continue, you must agree to Gruppo Food Terms of Service and Privacy Policy`,
                    ".",
                    react_1.default.createElement("br", null),
                    localLang !== 'it_IT' && (react_1.default.createElement(Button_1.Button, { label: t `Clicca per leggerli in Italiano`, onClick: () => {
                            setLang('it_IT');
                        }, layout: Button_1.layouts.LINK, type: "alt" })),
                    localLang !== 'en_US' && (react_1.default.createElement(Button_1.Button, { label: t `Click here to read them in English`, onClick: () => setLang('en_US'), layout: Button_1.layouts.LINK, type: "alt" }))),
                react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: text }, className: tosContainer }),
                extra && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("h3", null, t `Clausole vessatorie`),
                    react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: extra }, className: tosContainer }),
                    react_1.default.createElement(Checkbox_1.Checkbox, { label: t('I accept clausole vessatorie (required)'), checked: extraChecked, onChange: () => toggleExtra(!extraChecked) }))),
                react_1.default.createElement("div", { className: theme_1.footer },
                    react_1.default.createElement(Button_1.Button, { label: t('Back'), onClick: () => {
                            if (onBack) {
                                onBack();
                            }
                        } }),
                    react_1.default.createElement(Button_1.Button, { disabled: !(!extra || extraChecked), label: t('I Agree'), type: 'success', onClick: () => onAgree && onAgree({ id: tos.id, newsletter: false }) }))))));
};
exports.ToS = ToS;
//# sourceMappingURL=ToS.js.map